<template>
  <div class="header-before-form">
    <h1>{{ $t(title) }}</h1>
    <div class="create-description">{{ $t(description) }}</div>
  </div>
</template>

<script>
export default {
  name: 'BeforeFormHeader',
  props: {
    title: String,
    description: String
  }
}
</script>

<style scoped lang="scss">
.header-before-form {
  //max-width: 502px;
}

h1 {
  font-style: normal;
  font-weight: bold;
  font-family: 'Open Sans', sans-serif;
  font-size: 64px;
  line-height: 87px;
  color: #071D2D;
  @media (max-width: 768px) {
    font-size: 40px;
    line-height: 55px;
  }
}

.create-description {
  font-size: 21px;
  line-height: 28px;
  color: #6E777A;
  margin-bottom: 20px;
}
</style>
